import { proxy, useSnapshot } from "valtio"
import { FlyingCarpetTab } from "./carpet-panels"

let closeTimer = 0
const store = proxy({
  isOpen: false,
  tab: null as null | FlyingCarpetTab,
  launch(tab: FlyingCarpetTab) {
    clearTimeout(closeTimer)
    store.isOpen = true
    store.tab = tab
  },
  close() {
    clearTimeout(closeTimer)
    closeTimer = setTimeout(() => {
      store.isOpen = false
    }, 200) as any
  },
})

export function useFlyingCarpet() {
  return useSnapshot(store)
}

export function getFlyingCarpetStore() {
  return store
}
